import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { SparkleEffect } from '../components/SparkleEffect';
import { GlitterHeart } from '../components/GlitterHeart';
import { SplitFlapQuote } from '../components/SplitFlapQuote';
import { ArrowRightIcon, HeartIcon, MessageCircleIcon, PhoneIcon } from 'lucide-react';
export function FreeResourcesPage() {
  return <div className="min-h-screen bg-white pt-24 pb-24" data-id="element-1213">
      {/* Hero */}
      <section className="relative py-20 text-center overflow-hidden bg-gradient-to-b from-blush-50 to-white" data-id="element-1214">
        <SparkleEffect count={80} data-id="element-1215" />
        <div className="max-w-3xl mx-auto px-4 relative z-10" data-id="element-1216">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="font-heading text-5xl md:text-6xl font-bold text-plum-700 mb-6" data-id="element-1217">
            Trippin' Through <span className="text-cta-500" data-id="element-1218">Guidance</span>
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-xl text-plum-500 font-medium" data-id="element-1219">
            Tools, support, and a gentle reminder that you don't have to figure
            it all out alone.
          </motion.p>
        </div>
      </section>

      {/* SPARKLY QUOTE MARQUEE */}
      <SplitFlapQuote data-id="element-1220" />

      {/* REDESIGNED CRISIS SECTION */}
      <section className="py-16 bg-gradient-to-br from-lavender-50 via-blush-50 to-pink-50 relative overflow-hidden" data-id="element-1221">
        <SparkleEffect count={40} data-id="element-1222" />

        {/* Decorative blurred circles for soft glow */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-white/40 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3 pointer-events-none" data-id="element-1223" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-pink-100/40 rounded-full blur-3xl translate-y-1/2 -translate-x-1/3 pointer-events-none" data-id="element-1224" />

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-1225">
          <div className="text-center mb-12" data-id="element-1226">
            <GlitterHeart size={40} variant="light" className="mx-auto mb-4" data-id="element-1227" />
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-plum-700 mb-3" data-id="element-1228">
              If You're Not Okay Right Now
            </h2>
            <p className="text-plum-600 text-lg font-medium max-w-2xl mx-auto" data-id="element-1229">
              You're not alone. You don't have to go through this by yourself.
            </p>
          </div>

          {/* IMMEDIATE CRISIS HELP */}
          <div className="mb-12" data-id="element-1230">
            <h3 className="font-heading text-xl font-bold text-plum-700 mb-6 flex items-center gap-2" data-id="element-1231">
              <span className="text-2xl" data-id="element-1232">🚨</span> Immediate Crisis Help
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1233">
              {/* Card 1: Lifeline */}
              <div className="bg-white rounded-3xl p-6 shadow-md border border-blush-100 flex flex-col h-full" data-id="element-1234">
                <div className="flex items-center gap-3 mb-4" data-id="element-1235">
                  <div className="w-10 h-10 rounded-full bg-sky-50 flex items-center justify-center shrink-0" data-id="element-1236">
                    <PhoneIcon className="w-5 h-5 text-sky-500" data-id="element-1237" />
                  </div>
                  <h4 className="font-bold text-plum-800 text-lg" data-id="element-1238">
                    Suicide & Crisis Lifeline
                  </h4>
                </div>
                <div className="mb-4 flex-grow" data-id="element-1239">
                  <p className="text-plum-600 font-medium mb-1" data-id="element-1240">Call or text</p>
                  <p className="text-4xl font-black text-plum-800 mb-3 tracking-tight" data-id="element-1241">
                    988
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5 mb-1" data-id="element-1242">
                    <span className="text-cta-400" data-id="element-1243">Chat:</span> 988lifeline.org
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-1244">
                    <span data-id="element-1245">🕒</span> Available 24/7, free & confidential
                  </p>
                </div>
                <a href="https://988lifeline.org/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 w-full py-3 rounded-xl bg-sky-50 text-sky-600 hover:bg-sky-100 font-bold transition-colors mt-auto" data-id="element-1246">
                  Get Help Now <ArrowRightIcon className="w-4 h-4" data-id="element-1247" />
                </a>
              </div>

              {/* Card 2: Text Line */}
              <div className="bg-white rounded-3xl p-6 shadow-md border border-blush-100 flex flex-col h-full" data-id="element-1248">
                <div className="flex items-center gap-3 mb-4" data-id="element-1249">
                  <div className="w-10 h-10 rounded-full bg-cta-50 flex items-center justify-center shrink-0" data-id="element-1250">
                    <MessageCircleIcon className="w-5 h-5 text-cta-500" data-id="element-1251" />
                  </div>
                  <h4 className="font-bold text-plum-800 text-lg" data-id="element-1252">
                    Crisis Text Line
                  </h4>
                </div>
                <div className="mb-4 flex-grow" data-id="element-1253">
                  <p className="text-plum-600 font-medium mb-1" data-id="element-1254">
                    Text <strong className="text-plum-800" data-id="element-1255">HOME</strong> to
                  </p>
                  <p className="text-4xl font-black text-plum-800 mb-3 tracking-tight" data-id="element-1256">
                    741741
                  </p>
                  <p className="text-plum-500 text-sm font-medium mb-1" data-id="element-1257">
                    Connects you with a trained crisis counselor
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-1258">
                    <span data-id="element-1259">🕒</span> Available 24/7
                  </p>
                </div>
                <a href="https://www.crisistextline.org/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 w-full py-3 rounded-xl bg-cta-50 text-cta-600 hover:bg-cta-100 font-bold transition-colors mt-auto" data-id="element-1260">
                  Talk to Someone <ArrowRightIcon className="w-4 h-4" data-id="element-1261" />
                </a>
              </div>

              {/* Card 3: Emergency */}
              <div className="bg-white rounded-3xl p-6 shadow-md border border-blush-100 flex flex-col h-full" data-id="element-1262">
                <div className="flex items-center gap-3 mb-4" data-id="element-1263">
                  <div className="w-10 h-10 rounded-full bg-red-50 flex items-center justify-center shrink-0" data-id="element-1264">
                    <span className="text-xl" data-id="element-1265">🚓</span>
                  </div>
                  <h4 className="font-bold text-plum-800 text-lg" data-id="element-1266">Emergency</h4>
                </div>
                <div className="mb-4 flex-grow" data-id="element-1267">
                  <p className="text-plum-600 font-medium mb-1" data-id="element-1268">Call</p>
                  <p className="text-4xl font-black text-red-500 mb-3 tracking-tight" data-id="element-1269">
                    911
                  </p>
                  <p className="text-plum-500 text-sm font-medium" data-id="element-1270">
                    If someone is in immediate danger
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* SPECIALIZED SUPPORT */}
          <div className="mb-8" data-id="element-1271">
            <h3 className="font-heading text-xl font-bold text-plum-700 mb-6 flex items-center gap-2" data-id="element-1272">
              <span className="text-2xl" data-id="element-1273">💖</span> Specialized Support
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1274">
              {/* Trevor Project */}
              <div className="bg-white rounded-3xl p-6 shadow-sm border border-blush-100" data-id="element-1275">
                <div className="flex items-center gap-3 mb-3" data-id="element-1276">
                  <span className="text-2xl" data-id="element-1277">🌈</span>
                  <h4 className="font-bold text-plum-800" data-id="element-1278">LGBTQ+ Support</h4>
                </div>
                <p className="text-plum-500 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-1279">
                  The Trevor Project
                </p>
                <div className="space-y-2 mb-4" data-id="element-1280">
                  <p className="text-plum-700 font-bold text-lg" data-id="element-1281">
                    1-866-488-7386
                  </p>
                  <p className="text-plum-600 text-sm font-medium" data-id="element-1282">
                    Text <strong className="text-plum-800" data-id="element-1283">START</strong> to{' '}
                    <strong className="text-plum-800" data-id="element-1284">678678</strong>
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-1285">
                    <span data-id="element-1286">🕒</span> 24/7 support for LGBTQ+ youth
                  </p>
                </div>
                <a href="https://www.thetrevorproject.org/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-sm gap-1 text-cta-500 hover:text-cta-600 font-bold transition-colors" data-id="element-1287">
                  Get Support <ArrowRightIcon className="w-3 h-3" data-id="element-1288" />
                </a>
              </div>

              {/* SAMHSA */}
              <div className="bg-white rounded-3xl p-6 shadow-sm border border-blush-100" data-id="element-1289">
                <div className="flex items-center gap-3 mb-3" data-id="element-1290">
                  <span className="text-2xl" data-id="element-1291">🧠</span>
                  <h4 className="font-bold text-plum-800" data-id="element-1292">
                    Mental Health & Substance Use
                  </h4>
                </div>
                <p className="text-plum-500 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-1293">
                  SAMHSA National Helpline
                </p>
                <div className="space-y-2" data-id="element-1294">
                  <p className="text-plum-700 font-bold text-lg" data-id="element-1295">
                    1-800-662-4357
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-1296">
                    <span data-id="element-1297">🕒</span> 24/7, free, confidential
                  </p>
                </div>
              </div>

              {/* Postpartum */}
              <div className="bg-white rounded-3xl p-6 shadow-sm border border-blush-100" data-id="element-1298">
                <div className="flex items-center gap-3 mb-3" data-id="element-1299">
                  <span className="text-2xl" data-id="element-1300">👩‍👧</span>
                  <h4 className="font-bold text-plum-800" data-id="element-1301">
                    Postpartum Support
                  </h4>
                </div>
                <p className="text-plum-500 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-1302">
                  For Moms (EN/ES)
                </p>
                <div className="space-y-2 mb-4" data-id="element-1303">
                  <p className="text-plum-600 text-sm font-medium" data-id="element-1304">
                    Call or text:
                  </p>
                  <p className="text-plum-700 font-bold text-lg" data-id="element-1305">
                    1-800-944-4773
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-1306">
                    <span data-id="element-1307">🕒</span> Not 24/7, but very responsive
                  </p>
                </div>
                <a href="https://www.postpartum.net/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-sm gap-1 text-cta-500 hover:text-cta-600 font-bold transition-colors" data-id="element-1308">
                  Visit Website <ArrowRightIcon className="w-3 h-3" data-id="element-1309" />
                </a>
              </div>

              {/* Domestic Violence */}
              <div className="bg-white rounded-3xl p-6 shadow-sm border border-blush-100" data-id="element-1310">
                <div className="flex items-center gap-3 mb-3" data-id="element-1311">
                  <span className="text-2xl" data-id="element-1312">💔</span>
                  <h4 className="font-bold text-plum-800" data-id="element-1313">Domestic Violence</h4>
                </div>
                <p className="text-plum-500 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-1314">
                  National Hotline
                </p>
                <div className="space-y-2 mb-4" data-id="element-1315">
                  <p className="text-plum-700 font-bold text-lg" data-id="element-1316">
                    1-800-799-7233
                  </p>
                  <p className="text-plum-600 text-sm font-medium" data-id="element-1317">
                    Text <strong className="text-plum-800" data-id="element-1318">START</strong> to{' '}
                    <strong className="text-plum-800" data-id="element-1319">88788</strong>
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-1320">
                    <span data-id="element-1321">🕒</span> 24/7
                  </p>
                </div>
                <a href="https://www.thehotline.org/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-sm gap-1 text-cta-500 hover:text-cta-600 font-bold transition-colors" data-id="element-1322">
                  Get Support <ArrowRightIcon className="w-3 h-3" data-id="element-1323" />
                </a>
              </div>

              {/* Child Abuse */}
              <div className="bg-white rounded-3xl p-6 shadow-sm border border-blush-100" data-id="element-1324">
                <div className="flex items-center gap-3 mb-3" data-id="element-1325">
                  <span className="text-2xl" data-id="element-1326">👶</span>
                  <h4 className="font-bold text-plum-800" data-id="element-1327">
                    Child Abuse Hotline
                  </h4>
                </div>
                <p className="text-plum-500 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-1328">
                  Childhelp
                </p>
                <div className="space-y-2" data-id="element-1329">
                  <p className="text-plum-600 text-sm font-medium" data-id="element-1330">
                    Call or text:
                  </p>
                  <p className="text-plum-700 font-bold text-lg" data-id="element-1331">
                    1-800-422-4453
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-1332">
                    <span data-id="element-1333">🕒</span> 24/7
                  </p>
                </div>
              </div>
            </div>
          </div>

          <p className="text-center text-plum-500 font-medium italic mt-12" data-id="element-1334">
            Take a breath. You're going to be okay. 💗
          </p>
        </div>
      </section>

      {/* SECOND MARQUEE - extra positivity */}
      <SplitFlapQuote data-id="element-1335" />

      {/* FREE RESOURCES SECTION */}
      <section className="py-16 bg-white relative overflow-hidden" data-id="element-1336">
        <SparkleEffect count={60} data-id="element-1337" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-1338">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1339">
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-plum-700 mb-6" data-id="element-1340">
              Free Resources & Reset
            </h2>
            <p className="text-lg text-plum-600 font-medium leading-relaxed" data-id="element-1341">
              I've been through some really hard things in life—and I know what
              it feels like to feel stuck, overwhelmed, or alone. If that's
              where you are right now, please know this:{' '}
              <strong className="text-plum-800" data-id="element-1342">
                you matter, and you don't have to figure it all out by yourself.
              </strong>
            </p>
          </div>

          {/* Free Coaching Call - thin wide card above the grid */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mb-10" data-id="element-1343">
            <a href="https://calendly.com/trippinwithmandy/crisis-call" target="_blank" rel="noopener noreferrer" className="flex flex-col sm:flex-row items-center justify-between gap-4 bg-gradient-to-r from-cta-50 to-pink-50 rounded-2xl px-8 py-5 border-2 border-cta-200 shadow-md hover:shadow-lg hover:-translate-y-0.5 transition-all" data-id="element-1344">
              <div className="flex items-center gap-4" data-id="element-1345">
                <span className="text-3xl" data-id="element-1346">💗</span>
                <div data-id="element-1347">
                  <h3 className="font-heading text-lg font-bold text-plum-800" data-id="element-1348">
                    Need Someone to Talk To?
                  </h3>
                  <p className="text-plum-500 font-medium text-sm" data-id="element-1349">
                    Book a free coaching call — no strings, no judgment, just
                    support.
                  </p>
                </div>
              </div>
              <span className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-cta-500 text-white font-bold text-sm hover:bg-cta-600 transition-colors shadow-lg shadow-cta-500/20 shrink-0" data-id="element-1350">
                Book a Free Call
                <ArrowRightIcon className="w-4 h-4" data-id="element-1351" />
              </span>
            </a>
          </motion.div>

          {/* GRID ROW 1 */}
          <div id="free-lists" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-8 scroll-mt-32" data-id="element-1352">
            {/* Interactive Cleaning Schedule Card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-gradient-to-br from-cta-50 to-white rounded-3xl p-8 border-2 border-cta-200 shadow-md flex flex-col relative overflow-hidden" data-id="element-1353">
              <div className="absolute top-4 right-4 bg-cta-500 text-white text-xs font-bold px-4 py-2 rounded-full shadow-lg transform rotate-12" data-id="element-1354">
                NEW ✨
              </div>
              <div className="text-3xl mb-4" data-id="element-1355">✨</div>
              <h3 className="font-heading text-2xl font-bold text-plum-800 mb-4" data-id="element-1356">
                Free Interactive Cleaning Schedule
              </h3>
              <p className="text-plum-600 font-medium mb-8 flex-grow" data-id="element-1357">
                The Ultimate Cleaning Schedule — what to clean & when. Check
                things off, track your progress, use it every week for free!
              </p>
              <Link to="/free-resources/cleaning-schedule" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-cta-500 text-white font-bold text-sm hover:bg-cta-600 transition-colors shadow-lg shadow-cta-500/20 w-full" data-id="element-1358">
                Try It Now
                <ArrowRightIcon className="w-4 h-4" data-id="element-1359" />
              </Link>
            </motion.div>

            {/* Interactive Self-Care Schedule Card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-gradient-to-br from-pink-50 to-white rounded-3xl p-8 border-2 border-pink-200 shadow-md flex flex-col relative overflow-hidden" data-id="element-1360">
              <div className="absolute top-4 right-4 bg-pink-500 text-white text-xs font-bold px-4 py-2 rounded-full shadow-lg transform rotate-12" data-id="element-1361">
                NEW 🧖‍♀️
              </div>
              <div className="text-3xl mb-4" data-id="element-1362">🧖‍♀️</div>
              <h3 className="font-heading text-2xl font-bold text-pink-800 mb-4" data-id="element-1363">
                Free Interactive Self-Care Checklist
              </h3>
              <p className="text-pink-600 font-medium mb-8 flex-grow" data-id="element-1364">
                Daily hygiene and wellness ritual. Take care of your body and
                mind with this simple, trackable daily routine!
              </p>
              <Link to="/free-resources/self-care/daily" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-pink-500 text-white font-bold text-sm hover:bg-pink-600 transition-colors shadow-lg shadow-pink-500/20 w-full" data-id="element-1365">
                Try It Now
                <ArrowRightIcon className="w-4 h-4" data-id="element-1366" />
              </Link>
            </motion.div>

            {/* FREE WORKOUT CONSULTATION Card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.15
          }} className="bg-gradient-to-br from-sky-50 to-lavender-50 rounded-3xl p-8 border-2 border-sky-200 shadow-md flex flex-col relative overflow-hidden" data-id="element-1367">
              <div className="absolute top-4 right-4 bg-sky-500 text-white text-xs font-bold px-4 py-2 rounded-full shadow-lg transform rotate-12" data-id="element-1368">
                FREE 💪
              </div>
              <div className="text-3xl mb-4" data-id="element-1369">💪</div>
              <h3 className="font-heading text-2xl font-bold text-plum-800 mb-4" data-id="element-1370">
                Free Workout Consultation
              </h3>
              <p className="text-plum-600 font-medium mb-3 flex-grow" data-id="element-1371">
                Meet Jake — once the smallest in the room, now lifting over 500
                lbs and training for championship-level competition. His journey
                is proof of what consistency and discipline can do.
              </p>
              <p className="text-plum-500 text-sm font-medium mb-6" data-id="element-1372">
                Free consultations, zero pressure — just real advice from
                someone who's been exactly where you are.
              </p>
              <a href="https://calendly.com/trippinwithmandy/jakes-free-workout-consultation" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-sky-500 text-white font-bold text-sm hover:bg-sky-600 transition-colors shadow-lg shadow-sky-500/20 w-full" data-id="element-1373">
                Book Free Consultation
                <ArrowRightIcon className="w-4 h-4" data-id="element-1374" />
              </a>
            </motion.div>
          </div>

          {/* PANIC ATTACK GROUNDING - Full width between rows */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-br from-blush-50 to-lavender-50 rounded-3xl p-8 md:p-10 shadow-lg border border-blush-100 my-12" data-id="element-1375">
            <div className="text-center mb-6" data-id="element-1376">
              <div className="text-4xl mb-3" data-id="element-1377">🫧</div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-plum-700 mb-2" data-id="element-1378">
                Struggling with a Panic Attack?
              </h2>
              <p className="text-plum-500 font-semibold" data-id="element-1379">
                If you're having anxiety or a panic attack, try this grounding
                technique:
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto" data-id="element-1380">
              <div className="bg-white/80 rounded-2xl p-6 text-center border border-blush-100 shadow-sm" data-id="element-1381">
                <span className="text-3xl block mb-3" data-id="element-1382">👀</span>
                <h3 className="font-bold text-plum-800 text-lg mb-1" data-id="element-1383">
                  See 5 things
                </h3>
                <p className="text-plum-500 font-medium text-sm" data-id="element-1384">
                  Look around and name 5 things you can see right now.
                </p>
              </div>
              <div className="bg-white/80 rounded-2xl p-6 text-center border border-blush-100 shadow-sm" data-id="element-1385">
                <span className="text-3xl block mb-3" data-id="element-1386">✋</span>
                <h3 className="font-bold text-plum-800 text-lg mb-1" data-id="element-1387">
                  Feel 5 things
                </h3>
                <p className="text-plum-500 font-medium text-sm" data-id="element-1388">
                  Touch 5 different textures — your shirt, the table, your hair.
                </p>
              </div>
              <div className="bg-white/80 rounded-2xl p-6 text-center border border-blush-100 shadow-sm" data-id="element-1389">
                <span className="text-3xl block mb-3" data-id="element-1390">👂</span>
                <h3 className="font-bold text-plum-800 text-lg mb-1" data-id="element-1391">
                  Hear 5 things
                </h3>
                <p className="text-plum-500 font-medium text-sm" data-id="element-1392">
                  Close your eyes and listen for 5 sounds around you.
                </p>
              </div>
            </div>
            <p className="text-cta-500 font-bold text-center mt-6 text-sm italic" data-id="element-1393">
              This helps bring your mind back to the present moment. You're
              going to be okay. 💗
            </p>
          </motion.div>

          {/* GRID ROW 2 */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-1394">
            {/* Card 1 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-blush-50 rounded-3xl p-8 border border-blush-100 shadow-sm" data-id="element-1395">
              <div className="text-3xl mb-4" data-id="element-1396">🧘‍♀️</div>
              <h3 className="font-heading text-2xl font-bold text-plum-700 mb-4" data-id="element-1397">
                Things You Can Do Right Now
              </h3>
              <ul className="space-y-3 text-plum-600 font-medium" data-id="element-1398">
                <li className="flex items-start gap-2" data-id="element-1399">
                  <span className="text-cta-500 mt-1" data-id="element-1400">•</span> Take a deep
                  breath (seriously—slow it down)
                </li>
                <li className="flex items-start gap-2" data-id="element-1401">
                  <span className="text-cta-500 mt-1" data-id="element-1402">•</span> Drink some water
                </li>
                <li className="flex items-start gap-2" data-id="element-1403">
                  <span className="text-cta-500 mt-1" data-id="element-1404">•</span> Step outside for
                  a few minutes
                </li>
                <li className="flex items-start gap-2" data-id="element-1405">
                  <span className="text-cta-500 mt-1" data-id="element-1406">•</span> Text someone you
                  trust
                </li>
                <li className="flex items-start gap-2" data-id="element-1407">
                  <span className="text-cta-500 mt-1" data-id="element-1408">•</span> Put on music that
                  grounds you
                </li>
              </ul>
            </motion.div>

            {/* Card 2 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="bg-lavender-50 rounded-3xl p-8 border border-lavender-100 shadow-sm" data-id="element-1409">
              <div className="text-3xl mb-4" data-id="element-1410">📓</div>
              <h3 className="font-heading text-2xl font-bold text-plum-700 mb-4" data-id="element-1411">
                Quick Reset Questions
              </h3>
              <ul className="space-y-3 text-plum-600 font-medium" data-id="element-1412">
                <li className="flex items-start gap-2" data-id="element-1413">
                  <span className="text-cta-500 mt-1" data-id="element-1414">•</span> What am I feeling
                  right now?
                </li>
                <li className="flex items-start gap-2" data-id="element-1415">
                  <span className="text-cta-500 mt-1" data-id="element-1416">•</span> What do I
                  actually need today?
                </li>
                <li className="flex items-start gap-2" data-id="element-1417">
                  <span className="text-cta-500 mt-1" data-id="element-1418">•</span> What's one small
                  thing I can do?
                </li>
              </ul>
            </motion.div>

            {/* Card 3 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="bg-sky-50 rounded-3xl p-8 border border-sky-100 shadow-sm" data-id="element-1419">
              <div className="text-3xl mb-4" data-id="element-1420">🎧</div>
              <h3 className="font-heading text-2xl font-bold text-plum-700 mb-4" data-id="element-1421">
                My Go-To Distractions
              </h3>
              <ul className="space-y-3 text-plum-600 font-medium" data-id="element-1422">
                <li className="flex items-start gap-2" data-id="element-1423">
                  <span className="text-cta-500 mt-1" data-id="element-1424">•</span> A comfort show
                  (Gilmore Girls, anyone?)
                </li>
                <li className="flex items-start gap-2" data-id="element-1425">
                  <span className="text-cta-500 mt-1" data-id="element-1426">•</span> A podcast that
                  feels like talking to a friend
                </li>
                <li className="flex items-start gap-2" data-id="element-1427">
                  <span className="text-cta-500 mt-1" data-id="element-1428">•</span> Scrolling through
                  travel TikToks
                </li>
              </ul>
            </motion.div>
          </div>
        </div>
      </section>
    </div>;
}